module.exports = __webpack_public_path__ + "img/mark_take.a0f5b291.png";